import { createRoot } from 'react-dom/client';

import { SentryInit } from 'services/util/sentry';

import * as serviceWorker from './serviceWorker';

import '@effizency/efz-design-system/styles.css';
//Sentry
SentryInit();

const rootEl = document.getElementById('app-site');

// Create root for React 18
let root = null;

// Create a reusable render method that we can call more than once
let render = () => {
    // Dynamically import our main App component, and render it
    const MainApp = require('./MainApp').default;

    if (!root) {
        root = createRoot(rootEl);
    }

    root.render(<MainApp />);
};

if (module.hot) {
    module.hot.accept('./MainApp', () => {
        const MainApp = require('./MainApp').default;
        if (root) {
            root.render(<MainApp />);
        } else {
            render();
        }
    });
}

render();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
